import { render, staticRenderFns } from "./ImportWidget.vue?vue&type=template&id=512938f2&"
import script from "./ImportWidget.vue?vue&type=script&lang=js&"
export * from "./ImportWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports